import { createSelector } from 'reselect'

import { RootState } from 'state/reducer'

export const authorSelector = createSelector(
  (state: RootState, _id: string) => state.entities.authors.byId[_id],
  author => author
)
